import "../styles/bidding-list-item.scss";
import { getTimeDiff, fileExist } from "../shared/utils";
import { isMobile } from 'react-device-detect';
import ImageWithDefault from "./ImageWithDefault";
import { CountdownTimer } from "./CountdownTimer";

export const BiddingListItem = (props) => {
    const { data, status } = props;
    
    const carTitle = data?.countAdditionalCars > 0
        ? `Автомобильное комбо! ${data?.countAdditionalCars + 1} АВТО ПО ЦЕНЕ 1`
        : data?.car?.model?.name;

    return (
        <div key={data?.id} className="bidding-list-item">
            {isMobile && (
                <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginTop: 0 }}>
                    <ImageWithDefault src={data?.fileName}/>
                </div>)}
            <h3>Лот № {data?.id}. {carTitle}</h3>
            <p>г. {data?.city?.name}</p>
            {status === "active" ? <CountdownTimer endTime={data.dateEndBidding} /> : "Время вышло!"}
            <p><b>{data?.endPrice != null ? data?.endPrice?.toLocaleString('ru-RU') : data?.startPrice?.toLocaleString('ru-RU')} ₽</b></p>
        </div>
    )
}